import { FiliereTemplate } from '@/components/FiliereTemplate';

const filiereData = {
  name: "Anglais",
  icon: "🗣️",
  tagline: "Perfectionnez votre maîtrise de la langue anglaise et des cultures anglophones",
  duree: "3 à 5 ans",
  diplome: "Licence",
  mode: "Présentiel",
  nombreDebouches: "9",
  description: "La filière Anglais propose une formation approfondie en langue, littérature et culture anglaises. Notre programme développe les compétences linguistiques avancées nécessaires pour exceller dans divers domaines professionnels internationaux.",
  objectifs: [
    "Atteindre un niveau d'excellence en anglais oral et écrit",
    "Découvrir la littérature et culture anglophones",
    "Développer des compétences en traduction",
    "Maîtriser les techniques de communication professionnelle",
    "Préparer aux certifications internationales"
  ],
  programme: [
    { titre: "Licence 1 & 2", matieres: ["Grammaire avancée", "Expression orale et écrite", "Phonétique et prononciation", "Littérature anglaise", "Civilisation britannique et américaine", "Techniques de traduction"] },
    { titre: "Licence 3", matieres: ["Anglais des affaires", "Littérature contemporaine", "Linguistique appliquée", "Traduction spécialisée", "Communication interculturelle", "Méthodologie de l'enseignement"] }
  ],
  debouches: [
    { titre: "Traducteur", description: "Traduction de documents professionnels" },
    { titre: "Enseignant", description: "Enseignement de l'anglais" },
    { titre: "Interprète", description: "Interprétation simultanée ou consécutive" },
    { titre: "Diplomate", description: "Relations internationales" },
    { titre: "Responsable export", description: "Gestion des relations internationales" },
    { titre: "Journaliste international", description: "Médias internationaux" }
  ],
  competences: ["Maîtrise parfaite de l'anglais oral et écrit", "Compétences en traduction et interprétation", "Culture générale anglophone approfondie", "Capacité de communication interculturelle", "Rigueur linguistique et rédactionnelle"]
};

export default function Anglais() {
  return <FiliereTemplate filiere={filiereData} />;
}